<template>
  <div
    class="alignments"
    @click.stop
  >
    <a-popover
      v-for="alignedUser in alignedUsers"
      :key="alignedUser.id"
      overlay-class-name="objective-aligned-user"
    >
      <template #title>
        <router-link
          :to="{ name: 'UserOkr', params: { userId: alignedUser.id } }"
        >
          <AlignUser
            :user="alignedUser"
            :avatar-size="40"
            :text-size="16"
            style="margin: 4px 0;"
          />
        </router-link>
      </template>
      <template #content>
        <a-space direction="vertical">
          <AlignedOkr
            v-for="okrItem in alignedUser.okrItems"
            :key="okrItem.id"
            :entity="entity"
            :okr-item="okrItem"
            :can-edit="canEdit"
            v-bind="$attrs"
          />
        </a-space>
      </template>
      <span class="pointer">{{ alignedUser.nickname || alignedUser.name }}&nbsp;</span>
    </a-popover>
  </div>
</template>

<script>
import AlignUser from '@/components/AlignDialog/AlignUser'
import AlignedOkr from './AlignedOkr'
export default {
  name: 'AlignedUsers',
  components: {
    AlignUser,
    AlignedOkr
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    alignedUsers: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.alignments {
  position: relative;
  color: rgba(0, 0, 0, .5);
  font-weight: normal;
}
.pointer {
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    color: #64b5f6;
  }
}
</style>
